import React, { useState, useRef, useEffect } from 'react';
import logo from '../data/newlogo.png';
import whatsappIcon from '../data/wassup.png';

const BOT_AVATAR = '⚡';

function Chatbot({ isOpen, onClose }) {
  const [language, setLanguage] = useState(null);
  const [messages, setMessages] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => { scrollToBottom(); }, [messages, isTyping]);

  useEffect(() => {
    if (isOpen && messages.length === 0) {
      setMessages([{ id: Date.now(), text: 'Hello! 👋 I\'m Flash Support Bot. Please select your language to get started:', sender: 'bot', showLanguages: true }]);
    }
  }, [isOpen, messages.length]);

  const addBotMessage = (msg) => {
    setIsTyping(true);
    setTimeout(() => {
      setIsTyping(false);
      setMessages(prev => [...prev, { id: Date.now(), ...msg }]);
    }, 600);
  };

  const questions = {
    english: [
      { id: 1, q: '📦 Where is my order?', a: 'To track your order: Go to Profile → Order History → Click on your order to see live tracking.' },
      { id: 2, q: '🔍 How to track my order?', a: 'Open the app → Go to Profile → Order History → Select your order to view real-time tracking and delivery status.' },
      { id: 3, q: '📝 How to file a complaint?', a: 'Chat with us on WhatsApp with your order ID and issue details. We will help you within minutes!' },
      { id: 4, q: '⚠️ Issue with received item', a: 'If you received a damaged or wrong item, contact us on WhatsApp immediately with photos and order ID.' },
      { id: 5, q: '↩️ Return policy', a: 'We do not accept returns. However, if you receive damaged items, contact us on WhatsApp for quick assistance.' },
      { id: 6, q: '🚚 Delivery time', a: 'Delivery takes 30-60 minutes within 6 km, and 35-120 minutes for 6-12 km locations.' },
      { id: 7, q: '💳 Payment methods', a: 'We accept Cash on Delivery and UPI payment at the time of delivery. No online payment required!' },
      { id: 8, q: '💰 Delivery charges', a: 'Free delivery on orders ₹149+. ₹20 delivery fee for orders below ₹149. Minimum order ₹149.' }
    ],
    tamil: [
      { id: 1, q: '📦 என் ஆர்டர் எங்கே?', a: 'உங்கள் ஆர்டரை கண்காணிக்க: சுயவிவரம் → ஆர்டர் வரலாறு → உங்கள் ஆர்டரை கிளிக் செய்து நேரடி கண்காணிப்பைப் பார்க்கவும்.' },
      { id: 2, q: '🔍 என் ஆர்டரை எப்படி கண்காணிப்பது?', a: 'ஆப்பைத் திறக்கவும் → சுயவிவரம் → ஆர்டர் வரலாறு → உங்கள் ஆர்டரைத் தேர்ந்தெடுத்து நேரடி கண்காணிப்பு மற்றும் விநியோக நிலையைப் பார்க்கவும்.' },
      { id: 3, q: '📝 புகார் எப்படி தெரிவிப்பது?', a: 'உங்கள் ஆர்டர் ஐடி மற்றும் பிரச்சனை விவரங்களுடன் WhatsApp இல் எங்களுடன் சேட் செய்யுங்கள். நிமிடங்களில் பதிலளிப்போம்!' },
      { id: 4, q: '⚠️ பெற்ற பொருளில் சிக்கல்', a: 'சேதமடைந்த அல்லது தவறான பொருள் கிடைத்தால், புகைப்படங்கள் மற்றும் ஆர்டர் ஐடியுடன் உடனடியாக WhatsApp இல் எங்களுடன் தொடர்பு கொள்ளவும்.' },
      { id: 5, q: '↩️ திரும்ப அனுப்பும் கொள்கை', a: 'நாங்கள் திரும்ப பெறுவதை ஏற்கவில்லை. இருப்பினும், சேதமடைந்த பொருட்கள் கிடைத்தால், உதவிக்கு WhatsApp இல் எங்களுடன் தொடர்பு கொள்ளவும்.' },
      { id: 6, q: '🚚 விநியோக நேரம்', a: '6 கிமீக்குள் 30-60 நிமிடங்கள், 6-12 கிமீ இடங்களுக்கு 35-120 நிமிடங்கள் ஆகும்.' },
      { id: 7, q: '💳 பணம் செலுத்தும் முறைகள்', a: 'விநியோக நேரத்தில் பணம் மற்றும் UPI பணம் செலுத்துதலை ஏற்றுக்கொள்கிறோம். ஆன்லைன் பணம் தேவையில்லை!' },
      { id: 8, q: '💰 விநியோக கட்டணம்', a: '₹149+ ஆர்டர்களுக்கு இலவச விநியோகம். ₹149க்கு கீழ் ₹20 கட்டணம். குறைந்தபட்ச ஆர்டர் ₹149.' }
    ],
    malayalam: [
      { id: 1, q: '📦 എന്റെ ഓർഡർ എവിടെ?', a: 'നിങ്ങളുടെ ഓർഡർ ട്രാക്ക് ചെയ്യാൻ: പ്രൊഫൈൽ → ഓർഡർ ഹിസ്റ്ററി → തത്സമയ ട്രാക്കിംഗ് കാണാൻ നിങ്ങളുടെ ഓർഡറിൽ ക്ലിക്ക് ചെയ്യുക.' },
      { id: 2, q: '🔍 എന്റെ ഓർഡർ എങ്ങനെ ട്രാക്ക് ചെയ്യാം?', a: 'ആപ്പ് തുറക്കുക → പ്രൊഫൈൽ → ഓർഡർ ഹിസ്റ്ററി → തത്സമയ ട്രാക്കിംഗും ഡെലിവറി സ്റ്റാറ്റസും കാണാൻ നിങ്ങളുടെ ഓർഡർ തിരഞ്ഞെടുക്കുക.' },
      { id: 3, q: '📝 പരാതി എങ്ങനെ നൽകാം?', a: 'നിങ്ങളുടെ ഓർഡർ ഐഡിയും പ്രശ്ന വിശദാംശങ്ങളും സഹിതം WhatsApp ൽ എളുപ്പത്തിൽ ബന്ധപ്പെടുക. മിനിറ്റിനുള്ളിൽ പ്രതികരിക്കും!' },
      { id: 4, q: '⚠️ ലഭിച്ച ഉൽപ്പന്നവുമായി ബന്ധപ്പെട്ട പ്രശ്നം', a: 'കേടായതോ തെറ്റായതോ ആയ ഇനം ലഭിച്ചാൽ, ഫോട്ടോകളും ഓർഡർ ഐഡിയും സഹിതം ഉടൻ WhatsApp ൽ എന്നെ ബന്ധപ്പെടുക.' },
      { id: 5, q: '↩️ റിട്ടേൺ പോളിസി', a: 'ഞങ്ങൾ റിട്ടേണുകൾ സ്വീകരിക്കുന്നില്ല. എന്നിരുന്നാലും, കേടായ ഇനങ്ങൾ ലഭിച്ചാൽ, സഹായത്തിനായി WhatsApp ൽ ബന്ധപ്പെടുക.' },
      { id: 6, q: '🚚 ഡെലിവറി സമയം', a: '6 കിലോമീറ്ററിനുള്ളിൽ 30-60 മിനിറ്റ്, 6-12 കിലോമീറ്റർ സ്ഥലങ്ങൾക്ക് 35-120 മിനിറ്റ് എടുക്കും.' },
      { id: 7, q: '💳 പേയ്മെന്റ് മാർഗങ്ങൾ', a: 'ഡെലിവറി സമയത്ത് ക്യാഷ് ഓൺ ഡെലിവറിയും UPI പേയ്മെന്റും സ്വീകരിക്കുന്നു. ഓൺലൈൻ പേയ്മെന്റ് ആവശ്യമില്ല!' },
      { id: 8, q: '💰 ഡെലിവറി ചാർജുകൾ', a: '₹149+ ഓർഡറുകൾക്ക് സൗജന്യ ഡെലിവറി. ₹149 ൽ താഴെയുള്ളവയ്ക്ക് ₹20 ഫീസ്. മിനിമം ഓർഡർ ₹149.' }
    ]
  };

  const handleLanguageSelect = (lang) => {
    const langNames = { english: 'English', tamil: 'தமிழ்', malayalam: 'മലയാളം' };
    const prompts = {
      english: 'Great! What can I help you with today?',
      tamil: 'சிறப்பு! இன்று நான் உங்களுக்கு எப்படி உதவலாம்?',
      malayalam: 'മികച്ചത്! ഇന്ന് ഞാൻ നിങ്ങളെ എങ്ങനെ സഹായിക്കണം?'
    };
    setLanguage(lang);
    setMessages(prev => [
      ...prev,
      { id: Date.now(), text: langNames[lang], sender: 'user' }
    ]);
    addBotMessage({ text: prompts[lang], sender: 'bot', showQuestions: true });
  };

  const handleQuestionSelect = (q) => {
    setSelectedQuestions(prev => [...prev, q.id]);
    const followUps = {
      english: 'Need more help?',
      tamil: 'மேலும் உதவி தேவையா?',
      malayalam: 'കൂടുതൽ സഹായം വേണോ?'
    };
    setMessages(prev => [...prev, { id: Date.now(), text: q.q, sender: 'user' }]);
    setIsTyping(true);
    setTimeout(() => {
      setIsTyping(false);
      setMessages(prev => [
        ...prev,
        { id: Date.now() + 1, text: q.a, sender: 'bot' },
        { id: Date.now() + 2, text: followUps[language], sender: 'bot', showFollowUp: true }
      ]);
    }, 700);
  };

  const handleFollowUp = (answer) => {
    const responses = {
      yes: { english: 'Yes, contact support', tamil: 'ஆம், ஆதரவைத் தொடர்பு கொள்ளவும்', malayalam: 'അതെ, സപ്പോർട്ടുമായി ബന്ധപ്പെടുക' },
      no: { english: 'No, thanks!', tamil: 'இல்லை, நன்றி!', malayalam: 'ഇല്ല, നന്ദി!' }
    };
    const whatsappPrompt = {
      english: 'Great! Chat with us on WhatsApp for personalized assistance. Our team is ready to help!',
      tamil: 'சிறப்பு! தனிப்பயனாக்கப்பட்ட உதவிக்கு WhatsApp இல் எங்களுடன் chat செய்யுங்கள். எங்கள் குழு உதவ தயாராக உள்ளது!',
      malayalam: 'മികച്ചത്! വ്യക്തിഗത സഹായത്തിനായി WhatsApp ൽ ഞങ്ങളുമായി സംവദിക്കുക. ഞങ്ങളുടെ ടീം സഹായിക്കാൻ തയ്യാറാണ്!'
    };
    const thanks = {
      english: '😊 Happy to help! Have a great day. Feel free to reach out anytime.',
      tamil: '😊 உதவ மகிழ்ச்சி! நல்ல நாள் வாழ்த்துக்கள். எப்போது வேண்டுமானாலும் தொடர்பு கொள்ளுங்கள்.',
      malayalam: '😊 സഹായിക്കാൻ സന്തോഷം! ഒരു നല്ല ദിവസം ആശംസിക്കുന്നു. എപ്പോൾ വേണമെങ്കിലും ബന്ധപ്പെടുക.'
    };

    setMessages(prev => [...prev, { id: Date.now(), text: responses[answer][language], sender: 'user' }]);
    if (answer === 'yes') {
      addBotMessage({ text: whatsappPrompt[language], sender: 'bot', showWhatsApp: true });
    } else {
      addBotMessage({ text: thanks[language], sender: 'bot' });
    }
  };

  if (!isOpen) return null;

  const remainingQuestions = language ? questions[language].filter(q => !selectedQuestions.includes(q.id)) : [];

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#f8f9fa', zIndex: 1000, display: 'flex', flexDirection: 'column' }}>
      {/* Header — matches home page style */}
      <header style={{
        background: 'white',
        borderBottom: '1px solid #f0f0f0',
        padding: '12px 16px',
        paddingTop: 'calc(12px + var(--safe-area-top, 0px))',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        flexShrink: 0,
        zIndex: 10
      }}>
        {/* Back / Close button — top left */}
        <button
          onClick={onClose}
          style={{
            background: '#f3f4f6',
            border: 'none',
            borderRadius: '50%',
            width: '38px',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            flexShrink: 0,
            fontSize: '18px',
            color: '#374151',
            transition: 'background 0.15s'
          }}
          aria-label="Go back"
        >
          ←
        </button>

        {/* Logo */}
        <img src={logo} alt="Flash" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
        <span style={{ fontSize: '18px', fontWeight: '800', color: 'var(--primary, #7c3aed)', letterSpacing: '0.3px' }}></span>

        {/* Title */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>Support Chat</div>
          <div style={{ fontSize: '12px', color: '#10b981', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#10b981', display: 'inline-block' }}></span>
            Online · Replies instantly
          </div>
        </div>
      </header>

      {/* Messages area */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        WebkitOverflowScrolling: 'touch'
      }}>
        {messages.map((msg) => (
          <div key={msg.id} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {/* Message bubble */}
            <div style={{ display: 'flex', justifyContent: msg.sender === 'user' ? 'flex-end' : 'flex-start', alignItems: 'flex-end', gap: '8px' }}>
              {msg.sender === 'bot' && (
                <div style={{
                  width: '30px', height: '30px', borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--primary, #7c3aed) 0%, #5b21b6 100%)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '14px', flexShrink: 0
                }}>{BOT_AVATAR}</div>
              )}
              <div style={{
                maxWidth: '78%',
                padding: '10px 14px',
                borderRadius: msg.sender === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                background: msg.sender === 'user'
                  ? 'linear-gradient(135deg, var(--primary, #7c3aed) 0%, #5b21b6 100%)'
                  : 'white',
                color: msg.sender === 'user' ? 'white' : '#1f2937',
                fontSize: '14px',
                lineHeight: '1.5',
                boxShadow: msg.sender === 'user' ? '0 2px 8px rgba(124,58,237,0.25)' : '0 1px 4px rgba(0,0,0,0.08)',
                whiteSpace: 'pre-line'
              }}>
                {msg.text}
              </div>
            </div>

            {/* Language selector */}
            {msg.showLanguages && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginLeft: '38px', marginTop: '4px' }}>
                {[
                  { key: 'english', label: '🇬🇧 English' },
                  { key: 'tamil', label: '🇮🇳 தமிழ் (Tamil)' },
                  { key: 'malayalam', label: '🇮🇳 മലയാളം (Malayalam)' }
                ].map(({ key, label }) => (
                  <button key={key} onClick={() => handleLanguageSelect(key)} style={{
                    padding: '12px 16px',
                    background: 'white',
                    border: '2px solid var(--primary, #7c3aed)',
                    borderRadius: '12px',
                    color: 'var(--primary, #7c3aed)',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'all 0.15s',
                    boxShadow: '0 1px 4px rgba(124,58,237,0.1)'
                  }}>{label}</button>
                ))}
              </div>
            )}

            {/* Question chips */}
            {msg.showQuestions && language && remainingQuestions.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginLeft: '38px', marginTop: '4px' }}>
                {remainingQuestions.map(q => (
                  <button key={q.id} onClick={() => handleQuestionSelect(q)} style={{
                    padding: '11px 14px',
                    background: 'white',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '12px',
                    color: '#374151',
                    fontSize: '13px',
                    fontWeight: '500',
                    textAlign: 'left',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                  }}>{q.q}</button>
                ))}
              </div>
            )}

            {/* Follow-up yes/no */}
            {msg.showFollowUp && (
              <div style={{ display: 'flex', gap: '8px', marginLeft: '38px', marginTop: '4px' }}>
                <button onClick={() => handleFollowUp('yes')} style={{
                  flex: 1, padding: '10px',
                  background: 'linear-gradient(135deg, var(--primary, #7c3aed) 0%, #5b21b6 100%)',
                  border: 'none', borderRadius: '12px', color: 'white',
                  fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(124,58,237,0.25)'
                }}>
                  {language === 'english' ? '👍 Yes' : language === 'tamil' ? '👍 ஆம்' : '👍 അതെ'}
                </button>
                <button onClick={() => handleFollowUp('no')} style={{
                  flex: 1, padding: '10px',
                  background: 'white', border: '1.5px solid #e5e7eb',
                  borderRadius: '12px', color: '#374151',
                  fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                }}>
                  {language === 'english' ? '✅ No, thanks' : language === 'tamil' ? '✅ இல்லை' : '✅ ഇല്ല'}
                </button>
              </div>
            )}

            {/* WhatsApp button */}
            {msg.showWhatsApp && (
              <div style={{ display: 'flex', gap: '8px', marginLeft: '38px', marginTop: '4px' }}>
                <a
                  href="https://wa.me/919123456789?text=Hi%20Flash%20Support%2C%20I%20need%20help%20with%20my%20order"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ flex: 1, textDecoration: 'none' }}
                >
                  <button style={{
                    width: '100%', padding: '12px',
                    background: '#25d366', border: 'none', borderRadius: '12px', color: 'white',
                    fontSize: '14px', fontWeight: '600', cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(37, 211, 102, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}>
                    <img src={whatsappIcon} alt="WhatsApp" style={{ width: '20px', height: '20px' }} />
                    {language === 'english' ? 'Chat on WhatsApp' : language === 'tamil' ? 'WhatsApp இல் சேட் செய்யுங்கள்' : 'WhatsApp ൽ സംവദിക്കുക'}
                  </button>
                </a>
              </div>
            )}
          </div>
        ))}

        {/* Typing indicator */}
        {isTyping && (
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
            <div style={{
              width: '30px', height: '30px', borderRadius: '50%',
              background: 'linear-gradient(135deg, var(--primary, #7c3aed) 0%, #5b21b6 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '14px', flexShrink: 0
            }}>{BOT_AVATAR}</div>
            <div style={{
              padding: '12px 16px', background: 'white', borderRadius: '18px 18px 18px 4px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '4px', alignItems: 'center'
            }}>
              {[0, 1, 2].map(i => (
                <span key={i} style={{
                  width: '7px', height: '7px', borderRadius: '50%', background: '#9ca3af',
                  animation: 'typingDot 1.2s ease-in-out infinite',
                  animationDelay: `${i * 0.2}s`
                }} />
              ))}
            </div>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      {/* Footer hint */}
      <div style={{
        padding: '10px 16px',
        paddingBottom: 'calc(10px + var(--safe-area-bottom, 0px))',
        background: 'white',
        borderTop: '1px solid #f0f0f0',
        textAlign: 'center',
        fontSize: '12px',
        color: '#9ca3af',
        flexShrink: 0
      }}>
        ⚡ Flash Support · Tap a question above to get instant help
      </div>

      <style>{`
        @keyframes typingDot {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-5px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default Chatbot;

// Made with Bob
